import {app_singleton} from "../../utility/app_singleton";
import LoadingPopup, {loading} from "./loading_popup";

export default class CallbackComponent implements loading.ILoadingStrategy {

    constructor(
        public obj: app_singleton.loading_popup_data,
        protected post: {
            success_ca: () => void,
            error_ca: (err: Error) => void,
        },
        private father: LoadingPopup,
        private loading_component: loading.LoadingComponent
    ) {
        this.start_promise()
    }

    start_promise() {
        this.obj.promise.then(() => {
            this.post.success_ca()
        })
            .catch(e => this.post.error_ca(e))
            .finally(() => this.father.close())
    }

    handle_close() {
        return;
    }

    render() {
        return this.loading_component.render();
    }
}